import {
  catchError,
  concatMap,
  defaultIfEmpty,
  defer,
  Observable,
  of,
  ReplaySubject,
  Subject,
  take,
  tap,
} from 'rxjs';

interface QueuedSave {
  run: () => Observable<boolean>;
  result: ReplaySubject<boolean>;
}

export class SaveQueue {
  private readonly pending = new Subject<QueuedSave>();

  constructor() {
    this.pending
      .pipe(
        concatMap(({ run, result }) =>
          defer(run).pipe(
            catchError(() => of(false)),
            defaultIfEmpty(false),
            take(1),
            tap((saved) => {
              result.next(saved);
              result.complete();
            }),
          ),
        ),
      )
      .subscribe();
  }

  enqueue(run: () => Observable<boolean>): Observable<boolean> {
    return defer(() => {
      const result = new ReplaySubject<boolean>(1);
      this.pending.next({ run, result });
      return result;
    });
  }
}
